export const defaultUpdateMemberPasswordFormPasswordFieldDisplayText = {
    label: 'New password'
};
//# sourceMappingURL=display-text.js.map